import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6d561b85")

_pushScopeId("data-v-6d561b85")
const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = { class: "filert-container" }
const _hoisted_3 = { class: "log-content" }
const _hoisted_4 = { class: "bs" }
const _hoisted_5 = { class: "bs" }
const _hoisted_6 = { class: "bs" }
const _hoisted_7 = { class: "log-content" }
const _hoisted_8 = { class: "bs" }
const _hoisted_9 = { class: "log-content" }
const _hoisted_10 = { class: "bs" }
_popScopeId()

import { reactive, ref, onMounted } from 'vue'

import { api } from '@/apis/user'

export default _defineComponent({
  expose: [],
  setup(__props) {

const statis = reactive({
  data: {
    registerCount: 0,
    onlineCount: 0,
    surplusCount: null,
    groupCount: null,
    noonlineCount: 0,
  }
})
const getData = async () => {
  const { data }: any = await api.detail.aggrefateInfo()
  statis.data = data.data
  statis.data.noonlineCount = statis.data.registerCount - statis.data.onlineCount
  console.log(statis)
}
onMounted(() => {
  getData()
})

return /*#__PURE__*/_withId((_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_row = _resolveComponent("el-row")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_el_row, { gutter: 9 }, {
          default: _withId(() => [
            _createVNode(_component_el_col, { span: 3 }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('dashboard.totalusers')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 3 }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('dashboard.online')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 3 }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('dashboard.offline')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, { gutter: 9 }, {
          default: _withId(() => [
            _createVNode(_component_el_col, { span: 3 }, {
              default: _withId(() => [
                _createVNode("span", _hoisted_4, _toDisplayString(statis.data.registerCount), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 3 }, {
              default: _withId(() => [
                _createVNode("span", _hoisted_5, _toDisplayString(statis.data.onlineCount), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 3 }, {
              default: _withId(() => [
                _createVNode("span", _hoisted_6, _toDisplayString(statis.data.noonlineCount), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode(_component_el_row, { gutter: 3 }, {
          default: _withId(() => [
            _createVNode(_component_el_col, { span: 3 }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('dashboard.groupNum')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, { gutter: 9 }, {
          default: _withId(() => [
            _createVNode(_component_el_col, { span: 3 }, {
              default: _withId(() => [
                _createVNode("span", _hoisted_8, _toDisplayString(statis.data.groupCount), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createVNode("div", _hoisted_9, [
        _createVNode(_component_el_row, { gutter: 9 }, {
          default: _withId(() => [
            _createVNode(_component_el_col, { span: 3 }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('dashboard.avaiable')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, { gutter: 9 }, {
          default: _withId(() => [
            _createVNode(_component_el_col, { span: 3 }, {
              default: _withId(() => [
                _createVNode("span", _hoisted_10, _toDisplayString(statis.data.surplusCount), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ])
  ]))
})
}

})